import React, { createContext, useContext } from "react";

import { styledWithConfig } from "../components/layout";

export type DomContext = {
  createPortal?: any;
  Link?: any;
  NavLink?: any;
};

const domContext = createContext<DomContext>({});

export default function makeDomProvider({
  Link,
  NavLink,
  createPortal
}: DomContext) {
  const StyledLink = styledWithConfig(Link, {
    shouldForwardProp: (prop, defaultValidatorFn) =>
      ["replace"].includes(prop as string) || defaultValidatorFn(prop)
  });
  const StyledNavLink = styledWithConfig(NavLink, {
    shouldForwardProp: (prop, defaultValidatorFn) =>
      ["activeStyle", "activeClassName", "exact"].includes(prop as string) ||
      defaultValidatorFn(prop)
  });

  return function DomProvider({ children }: { children: React.ReactNode }) {
    return (
      <domContext.Provider
        value={{
          createPortal,
          Link: StyledLink,
          NavLink: StyledNavLink
        }}
      >
        {children}
      </domContext.Provider>
    );
  };
}

export const useDom = () => useContext(domContext);
